export const WOMEN_REQUEST_PENDING = "WOMEN_REQUEST_PENDING";
export const WOMEN_DATA_FAILURE = "WOMEN_DATA_FAILURE";

//Get Shoes Data
export const GET_WOMEN_REQUEST_SUCCESSFUL = "GET WOMEN_REQUEST_SUCCESSFUL";

//Post Shoes Data
export const POST_WOMEN_REQUEST_SUCCESSFUL = "POST_WOMEN_REQUEST_SUCCESSFUL";